import type { ProjectTree } from '@gotti/sandbox-core';
import { baseNameOf } from './projectPaths';

interface EditorTabsProps {
  tree: ProjectTree;
  errors: Record<string, string[]>;
  openTabs: string[];
  currentPath: string | null;
  onTabClick: (path: string) => void;
  onTabClose: (path: string) => void;
}

export function EditorTabs({ tree, errors, openTabs, currentPath, onTabClick, onTabClose }: EditorTabsProps) {
  const showClose = openTabs.length > 1;

  return (
    <div className="editor-tabs sub-tabs" id="sub-tabs">
      {openTabs.map((path) => {
        if (!Object.hasOwn(tree.files, path)) return null;

        const fileErrors = errors[path];
        const hasErrors = !!fileErrors && fileErrors.length > 0;
        const isActive = path === currentPath;

        return (
          <button
            key={path}
            className={`editor-tab${isActive ? ' active' : ''}${hasErrors ? ' has-errors' : ''}`}
            data-testid={`editor-tab:${path}`}
            data-active={isActive ? 'true' : 'false'}
            onClick={() => onTabClick(path)}
            title={`${path}${hasErrors ? '\n' + fileErrors!.join('\n') : ''}`}
          >
            <span className="tab-name">{baseNameOf(path)}</span>
            {showClose && (
              <span
                className="tab-close"
                onClick={(e) => {
                  e.stopPropagation();
                  onTabClose(path);
                }}
                title="Close"
              >
                ×
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
